import React, { useState, useEffect } from "react";
import {
  Container,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  CircularProgress,
  Button,
  Box,
  TextField,
  Pagination, // Import Pagination from MUI
} from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { jsPDF } from "jspdf";
import axios from "axios";
import "jspdf-autotable"; 
import API_BASE_URL from "../config";

const AdminPayments = () => {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [total, setTotal] = useState(0);
  const [status, setStatus] = useState("");
  const [search, setSearch] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("");

  const fetchPayments = async () => {
    setLoading(true);
    try {
      // const response = await axios.get("http://localhost:5000/api/payments", {
      const response = await axios.get(`${API_BASE_URL}/payments`, {
        params: {
          page,
          limit,
          status,
          search,
          payment_method: paymentMethod,
        },
      });
      setPayments(response.data.payments);
      setTotal(response.data.total);
    } catch (error) {
      console.error("Error fetching payments:", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchPayments();
  }, [page, limit, status, search, paymentMethod]);

  
  const handleDownloadReport = () => {
    // Set custom page size to 400mm x 400mm
    const doc = new jsPDF({
      unit: "mm", // Use millimeters as the unit
      format: [400, 400], // Custom size: width 400mm and height 400mm
    });
  
    // Set font size to a smaller value to prevent large text
    doc.setFontSize(15); // Adjust the font size to a smaller one
  
    // Table header
    const columns = [
      "S.No",
      "Name",
      "Opportunity Type",
      "Amount",
      "Start Date",
      "End Date",
      "Status",
      "Payment Method",
      "Transaction ID",
    ];
  
    const rows = payments.map((payment, index) => [
      index + 1,
      payment.name,
      payment.opportunity,
      payment.amount,
      new Date(payment.start_date).toLocaleDateString(),
      new Date(payment.end_date).toLocaleDateString(),
      payment.status,
      payment.payment_method,
      payment.transaction_id,
    ]);
  
    const startX = 10; // Adjust the starting X position (left padding)
    let startY = 20; // Adjust the starting Y position (top padding)
    
    // Define column widths (reduce these to decrease space between columns)
    const columnWidths = [20, 40, 55, 35, 35, 40, 30, 50, 40]; // Adjust widths to fit content
  
    // Draw table header
    columns.forEach((col, index) => {
      doc.text(col, startX + columnWidths.slice(0, index).reduce((acc, width) => acc + width, 0), startY);
    });
    
    startY += 8; // Increase the space between the header and the rows
  
    // Draw rows
    rows.forEach((row) => {
      row.forEach((cell, index) => {
        const cellValue = cell !== undefined && cell !== null ? cell.toString() : ""; // Safe check for undefined or null
        doc.text(cellValue, startX + columnWidths.slice(0, index).reduce((acc, width) => acc + width, 0), startY);
      });
      startY += 6; // Adjust the space between rows
    });
  
    // Save the PDF
    doc.save("payment_report.pdf");
  };
  
  
  


  return (
    <Container maxWidth="lg" sx={{ mt: 5, mb:4 }}>
      <Typography variant="h4" color="primary" fontWeight="bold" textAlign="center" mb={3}>
        Admin Payments Management
      </Typography>

      <Box display="flex" justifyContent="space-between" mb={3}>
        <TextField
          label="Search"
          variant="outlined"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          sx={{ width: "30%" }}
        />
      </Box>

      {loading ? (
        <Box sx={{ textAlign: "center", mt: 3 }}>
          <CircularProgress />
        </Box>
      ) : (
        <>
          <Button
            variant="contained"
            color="success"
            startIcon={<FileDownloadIcon />}
            onClick={handleDownloadReport}
            sx={{ mb: 3 }}
          >
            Download Report
          </Button>

          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{color:"#42326e",fontSize:"1rem",fontWeight:"bold"}}>S.No</TableCell>
                <TableCell sx={{color:"#42326e",fontSize:"1rem",fontWeight:"bold"}}>Name</TableCell>
                <TableCell sx={{color:"#42326e",fontSize:"1rem",fontWeight:"bold"}}>Opportunity</TableCell>
                <TableCell sx={{color:"#42326e",fontSize:"1rem",fontWeight:"bold"}}>Amount</TableCell>
                <TableCell sx={{color:"#42326e",fontSize:"1rem",fontWeight:"bold"}}>Start Date</TableCell>
                <TableCell sx={{color:"#42326e",fontSize:"1rem",fontWeight:"bold"}}>End Date</TableCell>
                <TableCell sx={{color:"#42326e",fontSize:"1rem",fontWeight:"bold"}}>Status</TableCell>
                <TableCell sx={{color:"#42326e",fontSize:"1rem",fontWeight:"bold"}}>Payment Method</TableCell>
                <TableCell sx={{color:"#42326e",fontSize:"1rem",fontWeight:"bold"}}>Transaction ID</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {payments.map((payment, index) => (
                <TableRow key={payment.id}>
                  <TableCell>{payment.id}</TableCell>
                  <TableCell>{payment.name}</TableCell>
                  <TableCell>{payment.opportunity}</TableCell>
                  <TableCell>{payment.amount}</TableCell>
                  <TableCell>{new Date(payment.start_date).toLocaleDateString()}</TableCell>
                  <TableCell>{new Date(payment.end_date).toLocaleDateString()}</TableCell>
                  <TableCell>{payment.status}</TableCell>
                  <TableCell>{payment.payment_method}</TableCell>
                  <TableCell>{payment.transaction_id}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>

          {/* Pagination */}
          <Box display="flex" justifyContent="center" mt={4}>
            <Pagination
              count={Math.ceil(total / limit)}
              page={page}
              onChange={(event, value) => setPage(value)}
              color="primary"
            />
          </Box>
        </>
      )}
    </Container>
  );
};

export default AdminPayments;
